import { instance as axios } from "../axios";

import JWT from 'jsonwebtoken';

const TABLE = '/user/';

// initial state
const state = {
    session: false,
    user: null
}

// getters
const getters = {
    getState:function(state){
        return state;
    }
}

// actions
const actions = {

    getData({ commit }, params) {
        return axios
            .post(TABLE+"get/", { ...params })
            .then(res => {
                if(res.data.results == 1) {
                    commit('setSessionData', res.data.data[0] || null);
                    return true;
                }
                else {
                    commit('setSessionData', null);
                    return false;
                }
            })
            .catch(err => {
                commit('setSessionData', null);
                return false;
            });
        },
        
        signIn({ commit }, params) {
            return axios
            .post(TABLE+"login/", { ...params })
            .then(res => {
                if(res.data.results == 1) {
                    commit('setSessionData', res.data.data[0] || null);
                    return true;
                }
                else {
                    commit('setSessionData', null);
                    return false;
                }
            })
            .catch(err => {
                commit('setSessionData', null);
                return false;
        });
    },

    update({ dispatch }, params) {
        return axios
            .put(TABLE, { ...params })
            .then(res => {
                if(!res.data.errors) {
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    setSessionData ({ commit }, data) {
        return commit('setSessionData', data)
     }
}

// mutations
const mutations = {
    setSessionData(state, data) {
        if(data) {
            state.user = data;
            state.session = true;
        }
        else state.session = false;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/session.js